import styled from "styled-components";

export const Section = styled.section`
	padding-top: 5rem;
	background-color: #fff;

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 1rem;
	}
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column-reverse;
	align-items: center;
	gap: 2rem;
	text-align: center;

	@media (min-width: 992px) {
		flex-direction: row;
		text-align: left;
		gap: 4rem;
	}
`;

export const TextSide = styled.div`
	flex: 1;

	h2 {
		font-size: 2rem;
		font-weight: 700;
		color: #1a1a2e;
		margin-bottom: 1rem;

		@media (min-width: 768px) {
			font-size: 2.5rem;
		}

		@media (min-width: 992px) {
			font-size: 3rem;
		}
	}

	p {
		color: #6b7280;
		font-size: 1.1rem;
		line-height: 1.6;
		max-width: 480px;
		margin: 0 auto 1.5rem;

		@media (min-width: 992px) {
			margin: 0 0 1.5rem;
		}
	}
`;

export const ImageSide = styled.div`
	flex: 1;
	display: flex;
	justify-content: center;

	img {
		width: 14rem;

		@media (min-width: 576px) {
			width: 18rem;
		}

		@media (min-width: 992px) {
			width: 100%;
			max-width: 24rem;
		}
	}
`;

export const ActionButton = styled.a`
	display: inline-block;
	padding: 0.85rem 2rem;
	border-radius: 0.5rem;
	font-size: 1rem;
	font-weight: 600;
	cursor: pointer;
	text-decoration: none;
	transition: all 0.2s;
	background-color: #642b73;
	color: #fff;
	border: none;

	&:hover {
		background-color: #7a3590;
		transform: translateY(-1px);
	}
`;
